module.exports = __webpack_public_path__ + "img/Premium Clover 16.b8245630.jpg";